import { getDocument, GlobalWorkerOptions, version } from 'pdfjs-dist';

GlobalWorkerOptions.workerSrc = `https://unpkg.com/pdfjs-dist@${version}/legacy/build/pdf.worker.min.mjs`;
export const convertPDFBinary = async (binary: Uint8Array<ArrayBuffer>) => {
  if (typeof window === 'undefined') {
    return [] as string[];
  }

  const document = await getDocument({ data: binary }).promise;
  const pages = await Promise.all(
    Array.from({ length: document.numPages }).map(async (_, i) => {
      const page = await document.getPage(i + 1);
      const viewport = page.getViewport({ scale: 1 });
      const { canvas, context } = getCanvas(viewport.width, viewport.height);
      await page.render({ canvasContext: context, viewport, canvas }).promise;
      return canvas.toDataURL();
    })
  );

  return pages;
};

const getCanvas = (width: number, height: number) => {
  const canvas = document.createElement('canvas');
  canvas.height = height;
  canvas.width = width;
  const context = canvas.getContext('2d')!;
  return { canvas, context };
};

export type Attachment = {
  pages: string[];
};
